var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 w-100"},[(_vm.showTitle)?_c('p',{staticClass:"text-center display-2"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.source}})])}
var staticRenderFns = []

export { render, staticRenderFns }